import { Post } from 'components/Post';

const BlogPost = () => <Post sportCategory="nba" />;
export default BlogPost;
